import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Row,
  Col,
  Checkbox,
  Input,
} from "antd";
import service from "../../../services/citizenScienceLookupService";
import util from "../../../utils/functions/custom";
import { recordError } from "../../../utils/logService";
import { contribEnum } from "@seims/shared";

const EditObjectives = ({ data, visible, onCancel, onModalSubmit }) => {
  const [objectives, setObjectives] = useState([]);
  const [selectedObjectives, setSelectedObjectives] = useState([]);
  const [disabled, setDisabled] = useState(true);
  // const [showOtherObjectives, setShowOtherObjectives] = useState(false);
  const [form] = Form.useForm();
  const formName = "EditProjectObjectiveForm";

  useEffect(() => {
    getObjectives();
    loadProjectData();
  }, []);

  const loadProjectData = () => {
    if (!util.isEmpty(data)) {
      // const hasOther = data.objectives.find(
      //   (c) => c.value === contribEnum.OTHER
      // );
      console.log("DATA", data.otherObjectives);

      const _objectives = data.objectives?.map((d) => d.key);
      form.setFieldsValue({
        objectives: _objectives,
      });
      // if (hasOther) {
      //   setShowOtherObjectives(true);
      //   form.setFieldsValue({ otherObjectives: data.otherObjectives });
      // }
    }
  };

  const getObjectives = async () => {
    try {
      const response = await service.getObjectives();
      if (response && response.status === 200) {
        const { data } = response;
        const transformData = data.map((c) => ({
          label: c.value,
          value: c.key,
          key: c.key,
        }));
        setObjectives(transformData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onPopCancel = () => {
    onCancel();
    setDisabled(true);
    // form.resetFields();
  };

  const Confirm = () => {
    onCancel();
    form.resetFields();
  };

  const onChangeObjectives = (selectedValue) => {
    const selectedOptions = objectives?.filter((c) =>
      selectedValue.includes(c.key)
    );
    setSelectedObjectives(selectedOptions);
    // const otherSelected = selectedOptions.some((c) => c.label === "Other");
    // if (otherSelected) {
    //   setShowOtherObjectives(otherSelected);
    // } else {
    //   setShowOtherObjectives(otherSelected);
    // }
  };

  const onSubmit = async (values) => {
    try {
      let obj = [];
      if(selectedObjectives.length > 0)
      {
        selectedObjectives.forEach((da) => {
          obj.push({
            key: da.key,
            value: da.label,
            label: da.label,
          });
        });
      }
      else
      {
        values.objectives.forEach((da) => {
          const objective = objectives.find((o) => o.key === da);
          if(objective != undefined)
          {
            obj.push({
              key: da,
              value: objective.label,
              label: objective.label,
            });
          }
        });
      }
      onModalSubmit(obj);
    } catch (error) {
      recordError(error);
    }
  };

  return (
    <Modal
      title="Project Objectives - Edit"
      open={visible}
      closable={false}
      keyboard={false}
      maskClosable={false}
      onCancel={onCancel}
      width={700}
      footer={[
        <div className="modal-footer-buttons">
          <Popconfirm
            key="2"
            title="Are you sure you want to cancel...you will lose all info entered?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => Confirm()}
            onCancel={onPopCancel}
            disabled={disabled}
          >
            <Button onMouseUp={() => onPopCancel()} style={{ marginLeft: 10 }}>
              Cancel
            </Button>
          </Popconfirm>
          <Button
            type="primary"
            htmlType="submit"
            onSubmit={onSubmit}
            form={formName}
          >
            Update
          </Button>
        </div>,
      ]}
    >
      <Form
        disabled={false}
        form={form}
        name={formName}
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row>
          <Col xs={24} md={24} sm={24}>
            <Form.Item
              name="objectives"
              label="Project objectives"
              rules={[
                {
                  required: true,
                  message: "Please select an objective",
                },
              ]}
            >
              <Checkbox.Group
                onChange={onChangeObjectives}
                options={objectives}
                style={{ display: "flex", flexDirection: "column" }}
              />
            </Form.Item>
            {/* {showOtherObjectives && (
              <Form.Item
                name="otherObjectives"
                label="Other Project Objective"
                rules={[
                  {
                    required: true,
                    message: "Please provide other objective",
                  },
                ]}
              >
                <Row>
                  <Col xs={12} md={12} sm={12}>
                    <Input name="otherObjectives" />
                  </Col>
                </Row>
              </Form.Item>
            )} */}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditObjectives;
